<template>
	<div class="member-info-wrap">
		<b-row class="justify-content-lg-center">
		    <b-col lg="8" class="person-info-wrap member-info">
		        <b-card header="会员信息登记"
		            class="registerInfo">
		            <b-form>
		                <b-form-group label="会员账号:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input :value="getLoginCookieName() + getVerifyStatusText()"
		                        size="sm"
		                        readonly
		                        required
		                        placeholder="必填"></b-form-input>
		                </b-form-group>
						<b-form-group label="申请日期:"
						    label-cols-lg="2"
						    label-align-lg="right"
						    label-size="sm">
						    <b-form-input v-model="memberInfoTab.memberInfoForm.memberCreateTime"
						        size="sm"
						        required
								readonly
						        placeholder="必填"></b-form-input>
						</b-form-group>
                        <b-form-group label="账号类型:"
                            label-cols-lg="2"
                            label-align-lg="right"
                            label-size="sm">
                            <b-form-radio-group v-model="memberInfoTab.memberInfoForm.memberType"
                                @change="onMemberTypeChange">
                                <b-form-radio :value="1">个人</b-form-radio>
                                <b-form-radio :value="2">企业</b-form-radio>
                            </b-form-radio-group>
                        </b-form-group>
		                <b-form-group label="申请人:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input v-model="memberInfoTab.memberInfoForm.memberName"
		                        size="sm"
								required
								readonly
		                        placeholder="必填"></b-form-input>
		                </b-form-group>
						<b-form-group label="职务:"
						    label-cols-lg="2"
						    label-align-lg="right"
						    label-size="sm">
						    <b-form-select
						        size="sm"
						        required
						        @change="positionSelectConfirm" v-model="memberInfoTab.memberInfoForm.post">
						        <option placeholder="请选择申请人职务" v-for="(item,index) in positionList" :key="item.value" :value="item.label" >{{item.label}}</option>
						    </b-form-select>
						</b-form-group>

						<b-form-group label="场名:"
						    label-cols-lg="2"
						    label-align-lg="right"
							autocomplete="off"
						    label-size="sm">
						    <b-form-input v-model="memberInfoTab.memberInfoForm.userExternalCustomerFarmName"
						        size="sm"
						        required
						        placeholder="必填"></b-form-input>
						</b-form-group>
		                <b-form-group label="手机:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input v-model="memberInfoTab.memberInfoForm.memberPhone"
		                        size="sm"
		                        required
								readonly
		                        placeholder="必填"></b-form-input>
		                </b-form-group>
						<b-form-group label="温室面积:"
						    label-cols-lg="2"
						    label-align-lg="right"
							autocomplete="off"
						    label-size="sm">
						    <div class="areaunit">
						    	<b-form-input v-model="memberInfoTab.memberInfoForm.userExternalCustomerGreenhouseArea"
						    	    size="sm"
						    	    required
						    		type="number"
						    	    placeholder="必填">
						    	</b-form-input>
						    	<b-form-select
						    	    size="sm"
						    	    required
									class="area-unit"
						    	    @change="unitSelectConfirm" v-model="memberInfoTab.memberInfoForm.unit">
						    	    <option placeholder="请选择申请人职务" v-for="(unit,index) in areaList" :key="unit.value" :value="unit.label" >{{unit.label}}</option>
						    	</b-form-select>
						    </div>
						</b-form-group>
						<b-form-group label="省市县:"
						    label-cols-lg="2"
						    label-align-lg="right"
						    label-size="sm">
						    <b-form-select v-model="memberInfoTab.memberInfoForm.memberProvinceUuid"
						        size="sm"
						        class="formSelect"
						        @change="onProviceSelectChange">
						        <option value="">选择省份</option>
						        <option :value="item.regionUuid"
						            v-for="item in provinceList"
						            :key="item.regionUuid">
						            {{item.regionName}}
						        </option>
						    </b-form-select>
						    <b-form-select v-model="memberInfoTab.memberInfoForm.memberCityUuid"
						        size="sm"
						        class="formSelect"
						        @change="onCitySelectChange">
						        <option value="">选择城市</option>
						        <option :value="item.regionUuid"
						            v-for="item in cityList"
						            :key="item.regionUuid">
						            {{item.regionName}}
						        </option>
						    </b-form-select>
						    <b-form-select v-model="memberInfoTab.memberInfoForm.memberDistUuid"
						        size="sm"
						        class="formSelect"
						        @change="onDistSelectChangne">
						        <option value="">选择区县</option>
						        <option :value="item.regionUuid"
						            v-for="item in distList"
						            :key="item.regionUuid">
						            {{item.regionName}}
						        </option>
						    </b-form-select>
						</b-form-group>
						<b-form-group label="种植地址:"
						    label-cols-lg="2"
							autocomplete="off"
						    label-align-lg="right"
						    label-size="sm">
						    <b-form-input v-model="memberInfoTab.memberInfoForm.memberFullAddress"
						        size="sm"
						        placeholder="请填入详细地址，如乡（镇、街道办事处）、村（组）、门牌号等信息"></b-form-input>
						</b-form-group>
						<b-form-group label="收货地点:"
						    label-cols-lg="2"
						    label-align-lg="right"
						    label-size="sm" >
						    <b-form-radio-group @change="otherAddressChange" v-model="memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType">
						        <b-form-radio value="1" >本场地址</b-form-radio>
						        <b-form-radio value="2" >提货站</b-form-radio>
						        <b-form-radio value="3" >其他地点</b-form-radio>
						    </b-form-radio-group>
						</b-form-group>
                        <b-form-group v-show="stationFlag" label="提货站:"
                            label-cols-lg="2"
                            label-align-lg="right"
                            label-size="sm" >
                            <Select v-model="memberInfoTab.memberInfoForm.memberDefaultDistributionStationUuid"        
								clearable>
                                <Option class="station" :value="station.distributionStationUuid"
                                    v-for="station in stationList"
                                    :key="station.distributionStationUuid">
                                    {{station.distributionStationName}}-{{station.distributionStationFullAddress}}
                                </Option>
                            </Select>
                        </b-form-group>
						<b-form-group v-show="flag"
						    label="详细的收货地址:"
						    label-cols-lg="2"
						    label-align-lg="right"
							autocomplete="off"
						    label-size="sm">
						    <b-input-group>
						        <b-form-input size="sm"
						            v-model="memberInfoTab.memberInfoForm.otherAddress"></b-form-input>
						    </b-input-group>
						</b-form-group>
		                <b-form-group label="生产种类:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
							<b-form-input readonly v-model="memberInfoTab.memberInfoForm.selectMainCategoryStr"></b-form-input >
		                </b-form-group>

		                <b-form-group label="客户经理:"
		                    label-cols-lg="2"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <Select v-model="memberInfoTab.memberInfoForm.memberRelateCustomerManagerUuid"
		                        clearable
								disabled
		                        filterable>
		                        <Option v-for="item in memberInfoTab.allPassManagerList"
									:value="item.userCustomerManagerLoginUuid"
		                            :key="item.userCustomerManagerLoginUuid">{{item.userCustomerManagerName + ' ' + item.userCustomerManagerPhone}}</Option>
		                    </Select>
		                </b-form-group>
						<b-form-group label="微信:"
						    label-cols-lg="2"
						    label-align-lg="right"
						    label-size="sm" >
						    <figure>
						      <img :src="memberInfoTab.memberInfoForm.userCustomerManagerWechatFile" width="80rpx" height="80rpx">
						    </figure>
						</b-form-group>
		                <div style="float:right; margin-top:10px;" class="person-info-btn">
		                    <b-button @click="onSavePersonInfo"
		                        variant="primary">
		                        <b-spinner small
		                            v-if="memberInfoTab.modifyPersonBusySpin"></b-spinner>
		                        <span>保存修改</span>
		                    </b-button>
		                    <b-button variant="warning"
		                        @click="memberInfoTab.passwordModal.show = true">
		                        <span>修改密码</span>
		                    </b-button>
                            <b-button v-if="memberInfoTab.memberInfoForm.memberType == 2"
                                :disabled="memberInfoTab.memberInfoForm.memberCompanyFddVerifyStatus == '4'"
                                v-on:click="onRealNameVerify(2)"
                                variant="info">
                                <b-spinner small
                                    v-if="memberInfoTab.verifyPersonBusySpin"></b-spinner>
                                <span>{{memberInfoTab.memberInfoForm.memberCompanyFddVerifyStatus == '4' ? '企业已实名认证' : '企业实名认证'}}</span>
                            </b-button>
                            <b-button v-if="memberInfoTab.memberInfoForm.memberType == 1"
                                v-on:click="onRealNameVerify(1)"
                                :disabled="memberInfoTab.memberInfoForm.memberFddVerifyStatus == '2'"
                                variant="success">
                                <b-spinner small
                                    v-if="memberInfoTab.verifyPersonBusySpin"></b-spinner>
                                <span>{{memberInfoTab.memberInfoForm.memberFddVerifyStatus == '2' ? '个人已实名认证' : '个人实名认证'}}</span>
                            </b-button>
							<b-button v-if="memberInfoTab.memberInfoForm.memberType == 1 && memberInfoTab.memberInfoForm.memberFddVerifyStatus == '2'"
                                v-on:click="showSignatureModal"
                                variant="info">
                                <b-spinner small
                                    v-if="memberInfoTab.verifyPersonBusySpin"></b-spinner>
                                <span>上传个人签名</span>
                            </b-button>
							<b-button v-if="memberInfoTab.memberInfoForm.memberType == 1&&memberInfoTab.memberInfoForm.memberIsAddSignature == 1"
                                v-on:click="onAuthAutoSign"
                                :disabled="memberInfoTab.memberInfoForm.memberAuthAutoSign == 1"
                                variant="danger">
                                <b-spinner small
                                    v-if="memberInfoTab.verifyPersonBusySpin"></b-spinner>
                                <span>{{memberInfoTab.memberInfoForm.memberAuthAutoSign == 1 ? '个人已授权自签' : '个人授权自签'}}</span>
                            </b-button>
							<b-button v-if="memberInfoTab.memberInfoForm.memberType == 2 && memberInfoTab.memberInfoForm.memberCompanyFddVerifyStatus == '4'"
                                v-on:click="showSignatureModal"
                                variant="info">
                                <b-spinner small
                                    v-if="memberInfoTab.verifyPersonBusySpin"></b-spinner>
                                <span>上传企业印章</span>
                            </b-button>
                            <b-button v-if="memberInfoTab.memberInfoForm.memberType == 2&&memberInfoTab.memberInfoForm.memberCompanyIsAddSignature == 1"
                                :disabled="memberInfoTab.memberInfoForm.memberAuthAutoSign == 1"
                                v-on:click="onAuthAutoSign"
                                variant="danger">
                                <b-spinner small
                                    v-if="memberInfoTab.verifyPersonBusySpin"></b-spinner>
                                <span>{{memberInfoTab.memberInfoForm.memberAuthAutoSign == 1 ? '企业已授权自签' : '企业授权自签'}}</span>
                            </b-button>
		                </div>
		            </b-form>
		        </b-card>
		    </b-col>
		</b-row>

		<!-- 修改密码 -->
		<b-modal id="memberInfoTab.passwordModal"
		    v-model="memberInfoTab.passwordModal.show"
		    title="修改密码">
		    <b-row align-v="center">
		        <b-col lg="12">
		            <b-form>
		                <b-form-group label="新密码:"
		                    label-cols-lg="3"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input v-model="memberInfoTab.passwordModal.password"
		                        size="sm"
		                        required
		                        type="password"
		                        placeholder="输入新密码"></b-form-input>
		                </b-form-group>
		            </b-form>
		        </b-col>
		        <b-col lg="12">
		            <b-form>
		                <b-form-group label="确认新密码:"
		                    label-cols-lg="3"
		                    label-align-lg="right"
		                    label-size="sm">
		                    <b-form-input v-model="memberInfoTab.passwordModal.passwordConfirm"
		                        size="sm"
		                        required
		                        type="password"
		                        placeholder="确认新密码"></b-form-input>
		                </b-form-group>
		            </b-form>
		        </b-col>
		    </b-row>

		    <template slot="modal-footer">
		        <b-button size="sm"
		            variant="success"
		            @click="ResetPassword()">
		            <b-spinner small
		                v-if="memberInfoTab.modifyPersonBusySpin"></b-spinner>
		            保存
		        </b-button>
		        <b-button size="sm"
		            variant="danger"
		            @click="memberInfoTab.passwordModal.show = false">
		            取消
		        </b-button>
		    </template>
		</b-modal>
		<!-- 上传签名弹窗 -->
		<b-modal
			v-model="isSignatureShow"
			title="上传签名"
			size="lg"
			centered
			ok-title="上传"
            cancel-title="取消"
			@ok="handleSubmit"
			@cancel="handleCancel">
			<!-- 选择文件区域 -->
			<b-form-group label="选择图片文件">
				<b-form-file
				v-model="selectedFile"
				:state="Boolean(selectedFile)"
				placeholder="选择图片文件..."
				:browse-text="'选择文件'"
				drop-placeholder="拖放文件到这里..."
				accept=".jpg,.jpeg,.png"
				@change="handleFileSelect"
				></b-form-file>
				<b-form-text><strong>图片尺寸：企业章 166x166 像素，个人章 134x60 像素。支持格式: JPG, PNG, JPEG (最大 1MB)。需设置为透明底；</strong></b-form-text>
				<b-form-text>调整背景：<a href="https://www.insmind.com/zh-cn/remove-background-from-signature/" target="_blank">https://www.insmind.com/zh-cn/remove-background-from-signature/</a> <br/>
                             调整大小：<a href="https://www.iloveimg.com/zh-cn/resize-image" target="_blank">https://www.iloveimg.com/zh-cn/resize-image</a> <br/>
                             签名：<a href="https://signaturegen.ai/zh/tools/handwritten-signature-generator" target="_blank">https://signaturegen.ai/zh/tools/handwritten-signature-generator</a></b-form-text>
			</b-form-group>
			<!-- 预览 -->
			<div v-if="previewUrl" class="mt-3">
			<div class="text-muted mb-1">预览：</div>
			<b-img
				:src="previewUrl"
				thumbnail
				fluid
				alt="预览"
				style="max-height: 240px; object-fit: contain;"
			></b-img>
			</div>
        </b-modal>
	</div>
</template>

<script>
import api from '@/api/api';
import search from '@/libs/search';
import axios from 'axios';
export default {
    name: 'MemberInfo',
    data() {
        return {
			positionShow: false,
			memberModel: {
				show: false,
				position:'',
				areaunit:''
			},
			positionList: [
				{
					value: '请申请人选择职务',
					label: '请申请人选择职务'
				},
				{
					value: '老板',
					label: '老板'
				}, {
					value: '负责人',
					label: '负责人'
				}, {
					value: '主管',
					label: '主管'
				},
				{
					value: '董事长',
					label: '董事长'
				},
				{
					value: '总经理',
					label: '总经理'
				},
				{
					value: '经理',
					label: '经理'
				},
				{
					value: '其他',
					label: '其他'
				}

			],
			areaList: [
				{
					value: '平方米',
					label: '平方米'
				},
				{
					value: '亩',
					label: '亩'
				}
			],
			stationFlag:false,
			flag:false,
			radioChecked1:true,
			radioChecked2:false,
			radioChecked3:false,
			provinceList:[],
			cityList:[],
			distList:[],
			memberInfoTab: {
			    modifyPersonBusySpin: false,
			    verifyPersonBusySpin: false,
			    passwordModal: {
			        show: false,
			        password: '',
			        passwordConfirm: ''
			    },
			    memberInfoForm: {
					unit:'',
					post:'',
					userName:'',
			        userExternalCustomerFarmName:'',
			        userExternalCustomerGreenhouseArea:'',
					memberFullAddress:'',
			        memberPhone: '',
			        memberName: '',
					memberRelateCustomerManagerUuid:'',
					memberRelateCustomerManagerName: '',
					memberRelateCustomerManagerPhone:'',
			        memberCreateTime:'',
			        memberProvinceUuid: '',
			        memberCityUuid: '',
			        memberDistUuid: '',
					memberProvince: '',
					memberCity: '',
					memberDist: '',
					selectMainCategoryStr:'',
			        // memberProductionType: '',
			        // memberProductionTypeArray: [],
			        memberCateManagerRelation: [],
			        memberCateManagerRelationList: [],
			        memberLeftCateManagerUuid: '',
			        userCustomerManagerWechatFile:'',
			        distributionStationName:'',
			        otherAddress:'',
			        memberDeliveryAddressSelectType:1,
			        memberDeliveryAddressType:'收货',
                    memberDefaultDistributionStationUuid:'',
					memberFddSignatureImgUrl:'',
			    },
			    cateManagerRelation: [],
			    allPassManagerList: [],
			},
			provinceIndex: 0,
			cityIndex: 0,
			distIndex: 0,
			allRegionList: [],
            stationList: [],
			isSignatureShow: false,
			selectedFile: null,
			previewUrl: null,
		}
	},
	mounted() {
		this.getMemberDetailInfo();
		this.getMemberRegisterData();
        this.getStationList();
	},
	methods: {
		otherAddressChange(evt){
		    if(evt==3){
		    	//其他地点
		    	this.memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType=3;
		    	this.memberInfoTab.memberInfoForm.memberDeliveryAddressType='收货';
		    	this.stationFlag=false;
		    	this.flag=!this.flag;

		    }
		    else if(evt==2){
		    	//提货站
		    	this.memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType=2;
		    	this.memberInfoTab.memberInfoForm.memberDeliveryAddressType='自提';
		    	this.flag=false;
		    	this.stationFlag=!this.stationFlag;
		    }
		    else{
		    	//花场地址
		    	this.memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType=1;
		    	this.memberInfoTab.memberInfoForm.memberDeliveryAddressType='收货';
		    	this.flag=false;
		    	this.stationFlag=false;
		    }
		},
		//选择职务
		positionSelectConfirm(e) {
			this.memberModel.position = e[0].value;
		},
		
		//选择职务
		unitSelectConfirm(e) {
			this.memberModel.areaunit = e[0].value;
		},
		onProviceSelectChange(value) {
		    this.cityList = [];
		    this.distList = [];
		    if (value) {
		        this.cityList = this.regionList.filter(e => {
		            return e.regionParentUuid === value;
		        });
		    }
            this.memberInfoTab.memberInfoForm.memberProvinceUuid = value;

		},
		onCitySelectChange(value) {
		    this.distList = [];
		    if (value) {
		        this.distList = this.regionList.filter(e => {
		            return e.regionParentUuid === value;
		        });
		    }
            this.memberInfoTab.memberInfoForm.memberCityUuid = value;
		},
		onDistSelectChangne(value) {
		    this.memberInfoTab.memberInfoForm.memberDistUuid = value;
		},
		getCurDate() {
		    let curDate = new Date();
		    this.memberInfoTab.memberInfoForm.memberCreateTime = curDate.getFullYear() + "-" + (curDate.getMonth() + 1) + "-" + curDate.getDate();
		},
        onMemberTypeChange(e) {
            this.$Modal.confirm({
                title: '确认',
                content: '更改账号类型，需要重新做实名认证，确认修改？',
                okText: '是',
                onOk: () => {
                    this.updatePersonInfo();
                },
                cancelText: '否',
                onCancel: () => {
                    this.getMemberDetailInfo();
                }
            });
        },
        getVerifyStatusText() {
            if (this.memberInfoTab.memberInfoForm.memberType == 1) {
                if (this.memberInfoTab.memberInfoForm.memberFddVerifyStatus == "2") {
                    return "（已实名认证）";
                }
                else {
                    return "（未实名认证）";
                }
            }
            else if (this.memberInfoTab.memberInfoForm.memberType == 2) {
                if (this.memberInfoTab.memberInfoForm.memberCompanyFddVerifyStatus == "4") {
                    return "（已实名认证）";
                }
                else {
                    return "（未实名认证）";
                }
            }
            else {
                return "（未知用户类型）";
            }
        },
		onRealNameVerify(registerType) {
		    this.memberInfoTab.verifyPersonBusySpin = true;
		    api.registerFddAccount({ registerType: registerType }).then(res => {
		        this.memberInfoTab.verifyPersonBusySpin = false;
		        if (res.code === 0) {
		            let decode = atob(res.data.data.url);
		            let verifyUrl = decodeURI(decode);
		            window.open(verifyUrl, "_blank");

					this.$bvModal.msgBoxConfirm('个人实名认证成功？', {
					title: '确认',
					okTitle: '是',
					cancelTitle: '否',
					centered: true
					})
						.then(confirmed => {
						this.$router.go(0);
					});
		        }
		    });
		},
		onAuthAutoSign() {
		    this.memberInfoTab.verifyPersonBusySpin = true;
		    api.autoSignAuth({}).then(res => {
		        this.memberInfoTab.verifyPersonBusySpin = false;
		        if (res.code === 0) {
		            window.open(res.data.url, "_blank");
					this.$bvModal.msgBoxConfirm('个人、企业授权自签成功？', {
					title: '确认',
					okTitle: '是',
					cancelTitle: '否',
					centered: true
					})
						.then(confirmed => {
						 this.$router.go(0);
					});
		        }
		    });
		},
		onDeleteManager(manager) {
		    let index = this.memberInfoTab.memberInfoForm.memberCateManagerRelationList.findIndex(e => {
		        return e.mateCategoryUuid === manager.mateCategoryUuid
		            && e.subCategoryUuid === manager.subCategoryUuid
		            && e.managerUuid === manager.managerUuid;
		    });
		    if (index !== -1) {
		        this.memberInfoTab.memberInfoForm.memberCateManagerRelationList.splice(index, 1);
		    }
		},
		getMemberDetailInfo() {
		    if (this.checkMemberLogin()) {
		        this.showSpin = true;
		        api.webGetMemberUserDetail({ userUuid: this.getLoginCookieUuid() }).then(res => {
		           if (res.code === 0) {
		           	this.memberInfoTab.memberInfoForm = res.data;
		           	if(this.memberInfoTab.memberInfoForm.post){
		           		this.memberModel.position=res.data.post;
		           	}
					if(this.memberInfoTab.memberInfoForm.unit){
						this.memberModel.areaunit=res.data.unit;
					}
		           	//日期
		           	let memberCreateTimeStr=res.data.memberCreateTime;
		           	if(memberCreateTimeStr){
		           		this.memberInfoTab.memberInfoForm.memberCreateTime=memberCreateTimeStr.substring(0,10);
		           	}
		           	else{
		           		this.getCurDate();
		           	}
		           	//收货地点
		           	if(this.memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType==3){
		           		this.memberInfoTab.memberInfoForm.memberDeliveryAddressType='收货';
		           		this.flag=true;
		           	}
		           	else if(this.memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType==2){
		           		this.memberInfoTab.memberInfoForm.memberDeliveryAddressType='自提';
		           		this.stationFlag=true;
		           	}
		           	else{
		           		this.memberInfoTab.memberInfoForm.memberDeliveryAddressType='收货';
		           	}
		           	//生产种类
		           	let mainCategoryStr='';
		           	this.memberInfoTab.memberInfoForm.memberProductionTypeArray = this.memberInfoTab.memberInfoForm.memberProductionType.split('|');
		           	let productionTypeArray=this.memberInfoTab.memberInfoForm.memberProductionTypeArray;
		           	productionTypeArray.forEach(e => {
		           		if(e!=''&&e!=null&&e!=undefined){
		           			mainCategoryStr+='['+e+']';
		           		}
		           	});
		           	this.memberInfoTab.memberInfoForm.selectMainCategoryStr=mainCategoryStr;
                    if(this.memberInfoTab.memberInfoForm.userCustomerManagerWechatFile){
                        let wechatImg = JSON.parse(this.memberInfoTab.memberInfoForm.userCustomerManagerWechatFile).url.replace(/\\/g, '\/');
                    	this.memberInfoTab.memberInfoForm.userCustomerManagerWechatFile = api.fileServer + wechatImg;
                    }
		           	//客户经理
		           	if(this.memberInfoTab.memberInfoForm.memberRelateCustomerManagerUuid){
		           		this.memberInfoTab.memberInfoForm.memberRelateCustomerManagerName=this.memberInfoTab.memberInfoForm.memberRelateCustomerManagerName+' '+this.memberInfoTab.memberInfoForm.memberRelateCustomerManagerPhone
		           	}
					if(this.memberInfoTab.memberInfoForm.memberFddSignatureImgUrl){
						this.previewUrl = api.fileServer + this.memberInfoTab.memberInfoForm.memberFddSignatureImgUrl;
					}
		           }
		        });
		    }
		    else {
		        this.$router.push({
		            name: 'MemberLogin'
		        });
		    }
		},
        getStationList() {
            api.webGetAllDistributionStationList({}).then(res => {
                if (res.code === 0) {
                    this.stationList = res.data.distributionStations;
                }
            });
        },
		getMemberRegisterData() {
			this.cityList = [];
			this.distList = [];
		    api.getMemberRegisterData({}).then(res => {
		        if (res.code === 0) {
		            this.memberInfoTab.cateManagerRelation = res.data.cateManagerRelation.records;
		            this.memberInfoTab.allPassManagerList = res.data.cateManagerRelation.allPassMangers;
		            this.regionList = res.data.allRegions.allRegions;
		            this.provinceList = this.regionList.filter(e => {
		                return e.regionType === 1;
		            });
					if (this.memberInfoTab.memberInfoForm.memberProvinceUuid) {
					    this.cityList = this.regionList.filter(e => {
					        return e.regionParentUuid === this.memberInfoTab.memberInfoForm.memberProvinceUuid
					    });
					}
					if (this.memberInfoTab.memberInfoForm.memberCityUuid) {
					    this.distList = this.regionList.filter(e => {
					        return e.regionParentUuid === this.memberInfoTab.memberInfoForm.memberCityUuid;
					    });
					}
		        }
		    });
		},
		ResetPassword() {
		    this.memberInfoTab.modifyPersonBusySpin = true;
		    api.webResetMemberPassword(this.memberInfoTab.passwordModal).then(res => {
		        this.memberInfoTab.modifyPersonBusySpin = false;
		        if (res.code === 0) {
		            this.$bvModal.msgBoxOk("修改成功", {
		                title: '提示',
		                buttonSize: 'sm'
		            });
		            this.memberInfoTab.passwordModal.show = false;
		        }
		    });
		},
		onSavePersonInfo() {
		    this.updatePersonInfo();
		},
		updatePersonInfo() {
		   if (this.memberInfoTab.memberInfoForm.userName =='') {
			this.$bvModal.msgBoxOk('请输入会员号');
			return;
		   }
		   if (this.memberInfoTab.memberInfoForm.memberName =='') {
		   this.$bvModal.msgBoxOk('请输入申请人');
			return;
		   }
		   if (this.memberModel.position =='') {
			this.$bvModal.msgBoxOk('请选择负责人职位');
			return;
		   }
		   if (this.memberInfoTab.memberInfoForm.userExternalCustomerFarmName==='') {
			this.$bvModal.msgBoxOk('请输入场名');
			return;
		   }
		   if (this.memberInfoTab.memberInfoForm.memberPhone === '') {
			this.$bvModal.msgBoxOk('请输入手机号');
			return;
		   }
		   if (this.memberInfoTab.memberInfoForm.userExternalCustomerGreenhouseArea==='') {
			this.$bvModal.msgBoxOk('请输入温室面积');
			return;
		   }
		   if (this.memberModel.areaunit =='') {
				this.$bvModal.msgBoxOk('请选择温室面积单位');
				return;
		   }
		   if (this.memberInfoTab.memberInfoForm.memberProvinceUuid=='') {
		   			this.$bvModal.msgBoxOk('请选择种植地省份');
		   			return;
		   }
		   if (this.memberInfoTab.memberInfoForm.memberCityUuid=='') {
		   			this.$bvModal.msgBoxOk('请选择花场种植地城市');
		   			return;
		   }
		   if (this.memberInfoTab.memberInfoForm.memberDistUuid=='') {
		   			this.$bvModal.msgBoxOk('请选择花场种植地区县');
		   			return;
		   }
		   if (this.memberInfoTab.memberInfoForm.memberFullAddress=='') {
			this.$bvModal.msgBoxOk('请输入请填入种植的详细地址，如乡（镇、街道办事处）、村（组）、门牌号等信息');
			return;
		   }
		   if(this.memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType==2){
			if(this.memberInfoTab.memberInfoForm.memberDefaultDistributionStationUuid==''){
				this.$bvModal.msgBoxOk('请选择提货站');
				return;
			}
		   }
		   if(this.memberInfoTab.memberInfoForm.memberDeliveryAddressSelectType==3){
			if(this.memberInfoTab.memberInfoForm.otherAddress==''){
				this.$bvModal.msgBoxOk('请输入详细收货地址');
				return;
			}
		   }
		   if (this.memberInfoTab.memberInfoForm.memberRelateCustomerManagerUuid === '') {
			this.$bvModal.msgBoxOk('请选择客户经理');
			return;
		   }
		   api.webExternalCustomerUserRegisterByPhone(this.memberInfoTab.memberInfoForm).then(res => {
			if (res.code === 0) {
				this.setAddressStorage(res.data.defaultAddress);
				this.$bvModal.msgBoxOk('保存成功!');
			}else{
                this.$bvModal.msgBoxOk('保存过程出现异常，请联系管理员!');
            }
		});
		},
		showSignatureModal(){
			this.isSignatureShow = true;
		},
		handleFileSelect(event) {
			const file = event.target.files[0]
			if (!file) return

			// 验证文件类型
			const validTypes = ['image/jpeg', 'image/png', 'image/jpg']
			if (!validTypes.includes(file.type)) {
				this.$bvToast.toast('请选择有效的图片文件 (JPG, PNG, JPEG)', {
				title: '文件类型错误',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center'
				})
				this.selectedFile = null
				return
			}

			// 验证文件大小
			if (file.size > 1024*1024) {
				this.$bvToast.toast(`文件大小不能超过 1MB`, {
				title: '文件太大',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center'
				})
				this.selectedFile = null
				return
			}

			let param = new FormData(); // 创建form对象
            param.append('file', file, file.name); // 通过append向form对象添加数据
            let config = {
                headers: { 'Content-Type': 'multipart/form-data' }
            };
            let that = this;
            axios.post(api.uploadFile2Qiniu, param, config)
                .then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        let firstFile = res.data.fileList[0];
						that.memberInfoTab.memberInfoForm.memberFddSignatureImgUrl = firstFile.fileUuid;
                        that.previewUrl = api.fileServer  + firstFile.fileUuid;
                    }
                });

			//   this.fileInfo = {
			//     name: file.name,
			//     size: file.size,
			//     type: file.type
			//   }

			//   // 创建预览URL
			//   this.previewUrl = URL.createObjectURL(file)
		},
		handleSubmit(){
			if (!this.selectedFile) {
				this.$bvToast.toast('请选择图片', {
				title: '错误',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center'
				})
				return
			}
			//console.log(this.memberInfoTab.memberInfoForm.memberFddId);
			if (!this.memberInfoTab.memberInfoForm.memberFddId) {
				this.$bvToast.toast('请实名认证', {
				title: '错误',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center'
				})
				return
			}
			const formData = new FormData();
			formData.append('path', this.selectedFile);
			formData.append('customerId', this.memberInfoTab.memberInfoForm.memberFddId);
			formData.append('memberLoginUuid', this.memberInfoTab.memberInfoForm.memberLoginUuid);
			formData.append('memberFddSignatureImgUrl', this.memberInfoTab.memberInfoForm.memberFddSignatureImgUrl);
			api.AddSignature(formData).then(res => {
				if (res.code === 0) {
					this.$bvToast.toast('图片上传成功！', {
						title: '成功',
						variant: 'success',
						solid: true,
						toaster: 'b-toaster-top-center'
					});
					this.isSignatureShow = false;
					this.memberInfoTab.memberInfoForm.memberIsAddSignature = 1;
				}else{
					this.$bvToast.toast(res.message, {
						title: '错误',
						variant: 'danger',
						solid: true,
					    toaster: 'b-toaster-top-center'
					});
				}
			});
		},
		handleCancel(){
			this.selectedFile = null;
			this.isSignatureShow = false;
		}

	},
	computed: {
	    showSmsCode() {
	        return this.memberInfoTab.memberInfoForm.memberPhone !== this.memberInfoTab.memberInfoForm.memberPhoneOld;
	    }
	},
}
</script>

<style>
.registerInfo .form-group {
    margin-bottom: 15px;
}

.registerInfo .formSelect {
    width: 32%;
}

.form-text{
	padding: 4px 8px;
	color: #495057;
	border: 1px solid #ced4da;
	border-radius: 3px;
}
/* 个人信息修改提交按钮 */
.person-info-btn .btn-primary {color: #fff;background-color: #01B252;border-color: #01B252;}
.person-info-btn .btn-primary.focus, .person-info-btn .btn-primary:focus{
	background-color: #039f4a;
    border-color: #039f4a;
    box-shadow:none;
}


.person-info-btn .btn-warning {color: #fff;background-color: #e5ad06;border-color: #e5ad06;}
.person-info-btn .btn-warning:not(:disabled):not(.disabled).active, .person-info-btn .btn-warning:not(:disabled):not(.disabled):active, .person-info-btn .show>.btn-warning.dropdown-toggle{color:#fff;}
.person-info-btn .btn-warning.focus, .person-info-btn .btn-warning:focus{
	color:#fff;
	background-color: #d39f06;
    border-color: #d39f06;
    box-shadow:none;
}
.person-info-wrap .registerInfo{border: 1px solid rgba(0,0,0,.125);}
.person-info-wrap .card-header{text-align: center;padding:15px 0px;background-color: rgba(0,0,0,.03);border-bottom: 1px solid rgba(0,0,0,.125);}
.col-form-label-sm{margin-right:10px;}
.station{
	white-space: normal;
}
.areaunit{
	display: flex;
}
.area-unit{
	width: 120px;
}
</style>



// WEBPACK FOOTER //
// src/view/member/member-info.vue